import { render, staticRenderFns } from "./VaccineRegistrationExceptionHistory.vue?vue&type=template&id=9ccb3866&scoped=true"
import script from "./VaccineRegistrationExceptionHistory.vue?vue&type=script&lang=js"
export * from "./VaccineRegistrationExceptionHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccb3866",
  null
  
)

export default component.exports